
















































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { db, busy, VIPDocument, VIPDocumentRest, toaster, auth, IVIPDocument, getVIPDocumentCategoryList, VIPDocumentCategoryUnique } from "@/loader";
import { BusyMixin } from "@/mixins/BusyMixin";
import dayjs from "dayjs";

@Component
export default class DocumentEdit extends Mixins(BusyMixin) {
	@Prop({ type: VIPDocument, required: true })
	public item!: VIPDocument;

	public categories = getVIPDocumentCategoryList();
	public changed: boolean = false;
	public file: File | null = null;
	public focused: { [prop in keyof IVIPDocument]?: boolean; } = {
		name: false,
	};
	public invalidFeedback: { [prop in keyof IVIPDocument]?: string; } = {
		name: "Le nom ne doit pas être vide et ne doit aps dépasser 255 caractères",
	};

	public get states(): { [prop in keyof IVIPDocument]?: boolean | null; } {
		return {
			name: this.focused.name ? this.item.name.length > 0 && this.item.name.length <= 255 : null,
		};
	}

	public get canEdit(): boolean {
		return auth.user?.capabilities.edit_vip_document || false;
	}

	public get canDelete(): boolean {
		return auth.user?.capabilities.delete_vip_document || false;
	}

	public get isNew(): boolean {
		return this.item.id < 0;
	}

	public get isAdmin(): boolean {
		return auth.user?.isAdmin || false;
	}

	public get categoriesAvailable() {
		return this.categories.filter(x =>
			VIPDocumentCategoryUnique.indexOf(x.value) == -1
			|| !db.documents.list.find(y => y.category == x.value)
			|| this.item.category == x.value
		);
	}

	public get date_creation(): Date | null {
		return this.item.date_creation?.toDate() || null;
	}
	public set date_creation(value: Date | null) {
		this.item.date_creation = dayjs.nullable(value);
	}

	public get date_expiration(): Date | null {
		return this.item.date_expiration?.toDate() || null;
	}
	public set date_expiration(value: Date | null) {
		this.item.date_expiration = dayjs.nullable(value);
	}

	public check(): boolean {
		if (this.isNew && !this.file) {
			toaster.toast({ message: "Vous devez sélectionner un fichier.", variant: "warning", noAutoHide: false });
			return false;
		}
		return !Object.entries(this.states).some(([k, v]) => v === false);
	}

	public focusOn(prop: keyof IVIPDocument): void {
		this.$set(this.focused, prop, true);
		this.changed = true;
	}

	public unfocusAll(): void {
		for (let p in this.focused) {
			// @ts-ignore
			this.focused[p] = false;
		}
	}

	public focusAll(): void {
		for (let p in this.focused) {
			// @ts-ignore
			this.focused[p] = true;
		}
	}

	public fileChanged(event: InputEvent) {
		if (this.file) {
			this.item.name = this.file.name;
			this.item.size = this.file.size;
			this.item.mime_type = this.file.type;
		}
	}

	public cancel(): void {
		if (!this.item) {
			return;
		} else if (this.isNew) {
			db.documents.remove(this.item, true);
			this.$emit("cancelled", this.item);
		} else if (this.changed && this.item) {
			busy.start("Annulation des modifications ...");
			VIPDocumentRest.get(this.item).then(result => {
				if (result.success) {
					this.changed = false;
					this.unfocusAll();
					this.$emit("cancelled", this.item);
				}
			}).finally(() => {
				busy.stop();
			});
		} else {
			this.$emit("cancelled", this.item);
		}
	}

	public save() {
		if (!this.canEdit || !this.item) {
			return;
		}
		if (!this.check()) {
			toaster.toast({ message: "Certaines informations ne sont pas valides.", variant: "warning", noAutoHide: false });
			return;
		}
		busy.start("Sauvegarde du document ...");
		(this.item.id < 0 ? VIPDocumentRest.create(this.item) : VIPDocumentRest.update(this.item)).then(result => {
			if (result.success && result.item) {
				if (this.item.id < 0) {
					db.documents.remove(this.item, true);
					this.item = result.item;
				}
				if (this.file) {
					return VIPDocumentRest.uploadFile(this.item, this.file);
				}
			}
			return result;
		}).then(result => {
			if (result.success && result.item) {
				toaster.toast({
					message: "Le document a été enregistrée.",
					variant: "success",
					noAutoHide: false,
				});
				this.changed = false;
				this.unfocusAll();
				this.$emit("saved", this.item);
			}
		}).finally(() => {
			busy.stop();
		});
	}
}
